import {
  Flex,
  Image,
} from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import logo from '../../assets/image/logo.svg';
import Button from '../UI/Button/Button';

const NewHeader = () => {
  const handleButtonClick = () => {
    const url = 'https://app.alloydex.com';
    const newWindow = window.open(url, '_blank', 'noopener,noreferrer');
    if (newWindow) newWindow.opener = null;
  };
  return (
    <>
      <Flex
        zIndex={1000}
        position="fixed"
        top={0}
        bg="rgba(0, 0, 0, 0.2)" // Semi-transparent white background
        backdropFilter="blur(10px)" // Blur effect
        width="100%"
        padding={['15px', null, '15px 50px']}
        overflow="hidden"
        alignItems="center"
        justifyContent="space-between"
        color="white">
        {/* section 1 */}
        <Link to="/">
          <Image src={logo} height={['35px', null, '41px']} />
        </Link>
        {/* section 2 */}
        {/* <NavMenu display={['none', null, 'flex']} /> */}
        {/* section 3 */}
        <>
          <Button
            rounded="full"
            fontWeight={400}
            h="36px"
            w="136px"
            // display={['none', null, 'block']}
            onClick={handleButtonClick}>
            Launch App
          </Button>
          {/* TODO: 加上nav的时候需要取消注释 */}
          {/* <HamburgerIcon display={['block', null, 'none']} fontSize={'21px'} onClick={onOpen} /> */}
        </>
      </Flex>
      {/* <Drawer isOpen={isOpen} placement="right" onClose={onClose} size={'full'}>
        <DrawerOverlay />
        <DrawerContent bgColor={'black'}>
          <DrawerCloseButton color={'white'} />
          <DrawerBody
            display={'flex'}
            flexDir={'column'}
            alignItems={'flex-start'}
            justifyContent={'space-between'}
            paddingY="50px">
            <NavMenu />
            <Button rounded="full" fontWeight={400} h="36px" w="136px">
              Launch App
            </Button>
          </DrawerBody>
        </DrawerContent>
      </Drawer> */}
    </>
  );
};

export default NewHeader;
